import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function SectionHeading({ eyebrow, title, description, align, light }) {
  const titleColor = light ? "white" : "dark";
  const descriptionColor = light ? "white" : "text";

  return (
    <MKBox textAlign={align} mb={4}>
      {eyebrow && (
        <MKTypography
          variant="button"
          textTransform="uppercase"
          letterSpacing={2}
          color={light ? "info" : "info"}
        >
          {eyebrow}
        </MKTypography>
      )}
      <MKTypography variant="h2" color={titleColor} mt={1} mb={1.5}>
        {title}
      </MKTypography>
      {description && (
        <MKTypography
          variant="body2"
          color={descriptionColor}
          opacity={light ? 0.9 : 1}
          sx={{
            maxWidth: align === "center" ? "42rem" : "unset",
            mx: align === "center" ? "auto" : 0,
          }}
        >
          {description}
        </MKTypography>
      )}
    </MKBox>
  );
}

SectionHeading.defaultProps = {
  description: "",
  eyebrow: "",
  align: "left",
  light: false,
};

SectionHeading.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  align: PropTypes.oneOf(["left", "center", "right"]),
  light: PropTypes.bool,
};

export default SectionHeading;
